import { Container } from "inversify";
import "reflect-metadata";
import { IpfModule } from "..";
import { IpfApplication } from "../IpfApplication";
import { BootstrapMessageService } from "../react/component-services/BootstrapMessageService";
import { MaterialDataGridService } from "../react/component-services/MaterialDataGridService";
import { MaterialFormComponentService } from "../react/component-services/MaterialFormComponentService";
import { MaterialLoaderService } from "../react/component-services/MaterialLoaderService";
import { MaterialStepperService } from "../react/component-services/MaterialStepperService";
import { MaterialTierSelectorService } from "../react/component-services/MaterialTierSelectorService";
import { AjaxService, DataGridService, FormComponentService, FormService, LoaderService, MessageService, PageService, ScriptService, SearchFilterService, SessionValidationService, TierSelectorService, UrlService, UserTierService, ValidationService, WizardService } from "../services";
import { IpfFormService } from "../services/IpfFormService";
import { IpfPageService } from "../services/IpfPageService";
import { IpfScriptService } from "../services/IpfScriptService";
import { IpfSearchFilterService } from "../services/IpfSearchFilterService";
import { IpfSessionValidationService } from "../services/IpfSessionValidationService";
import { IpfUrlService } from "../services/IpfUrlService";
import { IpfUserTierService } from "../services/IpfUserTierService";
import { JQueryAjaxService } from "../services/JQueryAjaxService";
import { JQueryValidationService } from "../services/JQueryValidationService";
import { TYPES } from "./types";

/**
 * The dependency injection container for the client-side application. 
 */
export const container = new Container();

// register each concrete service type with corresponding identifier for injection
container.bind<AjaxService>(TYPES.AjaxService).to(JQueryAjaxService).inSingletonScope();
container.bind<FormComponentService>(TYPES.FormComponentService).to(MaterialFormComponentService).inSingletonScope();
container.bind<FormService>(TYPES.FormService).to(IpfFormService).inSingletonScope();
container.bind<DataGridService>(TYPES.DataGridService).to(MaterialDataGridService);
container.bind<LoaderService>(TYPES.LoaderService).to(MaterialLoaderService).inSingletonScope();
container.bind<MessageService>(TYPES.MessageService).to(BootstrapMessageService).inSingletonScope();
container.bind<PageService>(TYPES.PageService).to(IpfPageService).inSingletonScope();
container.bind<ScriptService>(TYPES.ScriptService).to(IpfScriptService).inSingletonScope();
container.bind<SearchFilterService>(TYPES.SearchFilterService).to(IpfSearchFilterService);
container.bind<SessionValidationService>(TYPES.SessionValidationService).to(IpfSessionValidationService).inSingletonScope();
container.bind<TierSelectorService>(TYPES.TierSelectorService).to(MaterialTierSelectorService).inSingletonScope();
container.bind<UrlService>(TYPES.UrlService).to(IpfUrlService).inSingletonScope();
container.bind<UserTierService>(TYPES.UserTierService).to(IpfUserTierService).inSingletonScope();
container.bind<ValidationService>(TYPES.ValidationService).to(JQueryValidationService).inSingletonScope();
container.bind<WizardService>(TYPES.WizardService).to(MaterialStepperService).inSingletonScope();
container.bind<IpfModule>(TYPES.IpfModule).to(IpfApplication).inSingletonScope();